var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "rounded-lg",
      attrs: {
        elevation: _vm.elevation,
        height: _vm.height,
        outlined: _vm.outlined,
      },
    },
    [
      _vm.title || _vm.showExpand
        ? _c(
            "v-card-title",
            { staticClass: "text-subtitle-1 pt-2" },
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _vm.loading
                ? _c("v-progress-circular", {
                    staticClass: "ml-2",
                    attrs: {
                      size: "16",
                      width: "2",
                      color: "secondary",
                      indeterminate: "",
                    },
                  })
                : _vm._e(),
              _c("v-spacer"),
              _vm._t("append-title"),
              _vm.showExpand
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-icon",
                                  _vm._g(
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit("expand")
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [_vm._v("mdi-fullscreen")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3214869348
                      ),
                    },
                    [_c("span", [_vm._v("Expand")])]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c("v-card-subtitle", { staticClass: "text-caption pb-2" }, [
        _vm._v(_vm._s(_vm.subtitle)),
      ]),
      _c("v-card-text", { staticClass: "pa-1" }, [_vm._t("default")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }